
export default {
  name: 'StarRatingDisplay',
  props: {
    rating: {
      type: Number,
      default: 0,
    },
    starSize: {
      type: Number,
      default: 16,
    },
    activeColor: {
      type: String,
      default: '#ffa41c',
    },
    inactiveColor: {
      type: String,
      default: '#ffe2b7',
    },
  },
  computed: {
    fillWidth() {
      const clamped = Math.max(0, Math.min(5, this.rating || 0))
      return `${(clamped / 5) * 100}%`
    },
    ariaLabel() {
      return `${this.rating}/5`
    },
  },
}
